(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["discount-badge"] && !Shopify.designMode) return;
  try {
    (function () {

    function copyToClipboard(text, callback) {

      if (navigator.clipboard && window.isSecureContext) {

        navigator.clipboard.writeText(text)
          .then(callback)
          .catch(function () {
            fallbackCopy(text, callback);
          });

      } else {

        fallbackCopy(text, callback);

      }

    }

    function fallbackCopy(text, callback) {

      var ta = document.createElement('textarea');

      ta.value = text;
      ta.setAttribute('readonly', '');
      ta.style.cssText =
        'position:fixed;top:-9999px;left:-9999px;opacity:0;';

      document.body.appendChild(ta);

      ta.focus();
      ta.select();

      try {

        document.execCommand('copy');
        callback();

      } catch (e) {

        console.warn('Discount badge: copy failed', e);

      }

      document.body.removeChild(ta);

    }

    document.addEventListener('click', function (e) {

      var btn = e.target.closest('.discount-badge-copy');

      if (!btn) return;

      var code = btn.dataset.code;

      if (!code) return;

      copyToClipboard(code, function () {

        btn.classList.add('is-copied');

        setTimeout(function () {

          btn.classList.remove('is-copied');

        }, 2000);

      });

    });

  })();
  } catch(e) { console.error(e); }
})();

})();
